export default "__VITE_ASSET__wz4tSIT4__"